import { useCallback, useState } from "react"
import { IconButton, Tooltip } from "@mui/material"
import { Share } from "@mui/icons-material"
import type { ShareSource } from "./resource-sharing"
import { ArtifactShareDialog } from "./artifact-share-dialog"

interface ArtifactShareButtonProps {
  source: ShareSource
  artifactName: string
  ariaLabel?: string
  testId?: string
}

export function ArtifactShareButton({ source, artifactName, ariaLabel = "Share artifact", testId }: ArtifactShareButtonProps) {
  const [open, setOpen] = useState(false)
  const onOpen = useCallback(() => setOpen(true), [])
  const onClose = useCallback(() => setOpen(false), [])

  return (
    <>
      <Tooltip title={ariaLabel}>
        <IconButton size="small" aria-label={ariaLabel} data-testid={testId} onClick={onOpen}>
          <Share fontSize="small" />
        </IconButton>
      </Tooltip>
      {/* Mounted on demand: the dialog owns three queries and a store subscription */}
      {open && <ArtifactShareDialog open onClose={onClose} source={source} artifactName={artifactName} />}
    </>
  )
}
